import { z } from "zod";
import { accountOverridesRequestSchema } from "../accounting/account-override.schema";

export const updateBillLineItemBodySchema = z
    .object({
        classIds: z.array(z.string().uuid()).optional(),
        accountOverrides: accountOverridesRequestSchema.optional(),
        accountsPayableOverrides: accountOverridesRequestSchema.optional(),
        // Transitional legacy fields. New callers should use the
        // per-ledger override arrays; these resolve to the entity's
        // primary accrual ledger server-side.
        accountId: z.string().uuid().nullable().optional(),
        accountsPayableId: z.string().uuid().nullable().optional(),
    })
    .refine(
        ({
            classIds,
            accountOverrides,
            accountsPayableOverrides,
            accountId,
            accountsPayableId,
        }) =>
            classIds !== undefined ||
            accountOverrides !== undefined ||
            accountsPayableOverrides !== undefined ||
            accountId !== undefined ||
            accountsPayableId !== undefined,
        {
            message:
                "classIds, accountOverrides, accountsPayableOverrides, accountId or accountsPayableId must be provided",
        },
    );
